import { constants } from '@/config';
import { useYourPosts as useFacebookYourPosts } from '@/app/facebook/useYourPosts';
import { useYourPosts as useInstagramYourPosts } from '@/app/instagram/useYourPosts';
import { useYourPosts as useInstagramStoriesYourPosts } from '@/app/instagram/useYourPostsStories';
import { useYourPosts as useLinkedInYourPosts } from '@/app/linkedin/useYourPosts';
import { useYourPosts as usePinterestYourPosts } from '@/app/pinterest/useYourPosts';
import { useYourPosts as useThreadsYourPosts } from '@/app/threads/useYourPosts';
import { useYourPosts as useTikTokYourPosts } from '@/app/tiktok/useYourPosts';
import { useYourPosts as useTwitterYourPosts } from '@/app/twitter/useYourPosts';
import { useYourPosts as useYouTubeYourPosts } from '@/app/youtube/useYourPosts';
import { useYourPosts as useSnapchatYourPosts } from '@/app/snapchat/useYourPosts';

export const YOUR_POSTS_CONFIG = Object.freeze({
  [constants.TIKTOK]: useTikTokYourPosts,
  [constants.PINTEREST]: usePinterestYourPosts,
  [constants.INSTAGRAM]: useInstagramYourPosts,
  [constants.INSTAGRAM_STORY]: useInstagramStoriesYourPosts,
  [constants.TWITTER]: useTwitterYourPosts,
  [constants.FACEBOOK]: useFacebookYourPosts,
  [constants.THREADS]: useThreadsYourPosts,
  [constants.LINKEDIN]: useLinkedInYourPosts,
  [constants.YOUTUBE]: useYouTubeYourPosts,
  [constants.SNAPCHAT]: useSnapchatYourPosts,
});
